import { Injectable } from '@angular/core';
import { ChangeLanguage, ResetLanguage, TranslationsActionTypes } from '@app/core/actions/translations';
import { PcsTranslateService } from '@app/core/translate/translate.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';

@Injectable()
export class TranslationsEffects {

  changeLanguage$ = createEffect(() => this.actions$.pipe(
    ofType<ChangeLanguage>(TranslationsActionTypes.ChangeLanguage),
    map(action => action.payload),
    tap(lang =>
      this.translationsService
        .changeLanguage(lang)
    )
  ), { dispatch: false });

  resetLanguage$ = createEffect(() => this.actions$.pipe(
    ofType<ResetLanguage>(TranslationsActionTypes.ResetLanguage),
    map(action => action.payload),
    tap(lang =>
      this.translationsService
        .resetLanguage(lang)
    )
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private translationsService: PcsTranslateService
  ) {}
}
